<template>
    <div
        :style="componentStyles"
        class="o-badge badge"
    >
        <img 
            :src="componentParams.icon"
            :alt="componentParams.altText"
            class="badge-icon"
        >
        <span class="badge-title">
            {{ $t(componentParams.title) }}

            <span class="badge-subtitle">
                {{ $t(componentParams.subtitle) }}
            </span>
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "OBadge",
    props: {
        view: {
            type: String,
            default: ''
        },
        configField: {
            type: String,
            default: 'OTilesGridWithScroll'
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.${this.configField}.params.badge.styles`) || null;
        },
        componentParams() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.${this.configField}.params.badge.params`) || null;
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>